module.exports = "<p>\n  kyc-upload works!\n</p>\n"